import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

// DESIGN-RULES R7 / SPEC-web-planner-033 AC-11 — the ask a form popup shows when Cancel or × is pressed after
// something was entered. The shared confirm dialog with fixed wording; pair it with DiscardGuard
// (shared/utils/discard-guard.ts). Place it after the popup's own overlay so it stacks above it.
@Component({
    selector: 'app-discard-confirm',
    template: `<app-confirm-dialog
        [open]="open"
        [title]="'Discard your changes?'"
        cancelLabel="Keep editing"
        confirmLabel="Discard"
        confirmTone="danger"
        (cancel)="keep.emit()"
        (confirm)="discard.emit()"
    ></app-confirm-dialog>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscardConfirmComponent {
    @Input() open = false;
    @Output() keep = new EventEmitter<void>();
    @Output() discard = new EventEmitter<void>();
}
